import React, { useState } from 'react';
import ChevronDownIcon from '@atlaskit/icon/glyph/chevron-down';
import ChevronUpIcon from '@atlaskit/icon/glyph/chevron-up';
import SectionMessage from '@atlaskit/section-message';

import { ValidationPathError } from '../../../../../../src/services/import-export/model';

import { ErrorsList, Title, Wrapper } from './UploadWarningMessageStyled';

interface Props {
    errors: ValidationPathError[];
    fileName?: string;
}

const UploadWarningMessage: React.FC<Props> = ({ errors, fileName = '' }) => {
    const [isErrorsListVisible, setIsErrorsListVisible] = useState(false);

    return (
        <Wrapper>
            <SectionMessage appearance='warning'>
                File <b>{fileName}</b> failed to import. Double check the file, search for missing values, or try again using a
                different file.
                <div>
                    <Title onClick={() => setIsErrorsListVisible(!isErrorsListVisible)}>
                        <div>
                            {isErrorsListVisible ?
                                <ChevronUpIcon label='hide' />
                            :   <ChevronDownIcon label='show' />}
                        </div>
                        <div>View the detailed errors</div>
                    </Title>
                    {isErrorsListVisible && (
                        <ErrorsList>
                            {errors.map(error => (
                                <li>
                                    <span>•</span>
                                    <span><b>{error.message}</b></span>
                                    <span>
                                        {error.path && (<>path: '{error.path}'</>)}
                                        {error.invalidValue && (<>, invalidValue: '{error.invalidValue}'</>)}
                                    </span>

                                </li>
                            ))}
                        </ErrorsList>
                    )}
                </div>
            </SectionMessage>
        </Wrapper>
    );
};

export default UploadWarningMessage;
